import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
  methods: {
    async generatePdf() {
      try {
        this.localBtnDisabled = true;
        // await this.getMember();
        let pdf = new jsPDF(this.pdfOption);

        // const margin_l = this.pdfConfig.margin.l;
        const margin_t = this.pdfConfig.margin.t;
        // =========================
        // GLOBAL MARGIN
        // =========================
        const PAGE_MARGIN_X = 15;
        const PAGE_MARGIN_TOP = 15;
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginX = 10;
        const marginTop = 5;

        let pdf_position_y = PAGE_MARGIN_TOP;

        const addNewPageIfNeeded = (incrementValue) => {
          if (pdf_position_y + incrementValue >= pdfHeight - margin_t) {
            pdf.addPage();
            pdf_position_y = margin_t; // Reset the position to the top of the new page
          } else {
            pdf_position_y += incrementValue; // Add the input value
          }
        };

        pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
        pdf.addFileToVFS("Sarabun-Regular.ttf", font);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

        pdf.setFont("Sarabun", "bold");

        pdf.setFontSize(this.pdfConfig.typo.header);
        pdf_position_y += margin_t;
        pdf.text(
          "รายงานการขายหลักสูตร",
          pdfWidth / 2,
          pdf_position_y,
          null,
          null,
          "center",
        );
        addNewPageIfNeeded(this.pdfConfig.endLegend);

        pdf.setFont("Sarabun", "normal");

        pdf.setFontSize(this.pdfConfig.typo.normal);
        pdf.setFontSize(9);
        this.thaitext(
          pdf,
          "วันที่พิมพ์ : " + this.formatDateToThaiShort(this.stringDate),
          pdfWidth - 20,
          pdf_position_y,
          0,
          "right"
        );

        addNewPageIfNeeded(this.pdfConfig.typo.normal);

        pdf.setFontSize(this.pdfConfig.typo.normal);
        this.thaitext(
          pdf,
          "ข้อมูลวันที่ : " +
            this.formatDateToThaiShort(this.courseSalesParamsValue.startDate) +
            " - " +
            this.formatDateToThaiShort(this.courseSalesParamsValue.endDate),
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "หมวดหมู่คอร์ส : " + this.courseSalesParamsLabel.cTagId,
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        this.thaitext(
          pdf,
          "วิชา : " + this.courseSalesParamsLabel.subjectId,
          pdfWidth - PAGE_MARGIN_X - 200,
          pdf_position_y,
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "สถานะคอร์ส : " + this.courseSalesParamsLabel.cStatus,
          PAGE_MARGIN_X,
          pdf_position_y,
          null,
          null,
          "left",
        );

        this.thaitext(
          pdf,
          "ช่องทางการชำระเงิน : " + this.courseSalesParamsLabel.method,
          pdfWidth - PAGE_MARGIN_X - 200,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        let hasCourseInfo = false;

        if (this.courseSalesParamsLabel.cCode) {
          this.thaitext(
            pdf,
            "รหัสคอร์ส : " + this.courseSalesParamsLabel.cCode,
            PAGE_MARGIN_X,
            pdf_position_y,
          );
          hasCourseInfo = true;
        }

        if (this.courseSalesParamsLabel.cId) {
          this.thaitext(
            pdf,
            "ชื่อคอร์ส : " + this.courseSalesParamsLabel.cId,
            this.courseSalesParamsLabel.cCode
              ? pdfWidth - PAGE_MARGIN_X - 200
              : PAGE_MARGIN_X,
            pdf_position_y,
          );
          hasCourseInfo = true;
        }

        if (hasCourseInfo) {
          addNewPageIfNeeded(this.pdfConfig.endNormal);
        }

        this.thaitext(
          pdf,
          "ประเภทคอร์ส : " + this.courseSalesParamsLabel.cType,
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        this.thaitext(
          pdf,
          "การขาย : " + this.courseSalesParamsLabel.paidFlag,
          pdfWidth - PAGE_MARGIN_X - 200,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf_position_y = pdf_position_y + marginTop;
        //table 1
        // ===== TABLE CONFIG =====
        const columns = [
          { key: "column1", title: "หลักสูตร", ratio: 4 },
          { key: "column2", title: "ยอดขาย (ครั้ง)", ratio: 1 },
          { key: "column3", title: "รวมเงิน (บาท)", ratio: 1 },
        ];

        // =========================
        // AUTO WIDTH
        // =========================
        const totalRatio = columns.reduce((sum, col) => sum + col.ratio, 0);

        const tableWidth = pdfWidth - (marginX * 2) - 15;

        columns.forEach((col) => {
          col.width = (col.ratio / totalRatio) * tableWidth;
        });

        // =========================
        // TABLE DATA
        // =========================
        const table1Data = this.courseSales?.map((item) => ({
          column1: item.courseName || "-",
          column2: item.count != null
            ? Number(item.count).toLocaleString("en-US", {})
            : "0",
          column3: item.sum != null
            ? Number(item.sum).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00",
        }));

        // ========================= // TOTAL // =========================
        const totalCount = this.courseSales?.reduce(
          (sum, item) => sum + Number(item.count || 0),
          0,
        );
        const totalSum = this.courseSales?.reduce(
          (sum, item) => sum + Number(item.sum || 0),
          0,
        );
        table1Data.push({
          column1: "รวมทั้งหมด",
          column2: totalCount || "0",
          column3: totalSum ? totalSum.toFixed(2) : "0.00",
        });
        // =========================
        // DRAW HEADER
        // =========================
        const HEADER_HEIGHT = 18;
        const HEADER_PADDING_TOP = 11;
        const drawHeader = () => {
          let currentX = PAGE_MARGIN_X;

          pdf.setFont("Sarabun", "bold");
          pdf.setFontSize(9);

          columns.forEach((col) => {
            pdf.setFillColor(230, 230, 230);

            pdf.rect(currentX, pdf_position_y, col.width, HEADER_HEIGHT);

            this.thaitext(
              pdf,
              col.title,
              currentX + col.width / 2 - pdf.getTextWidth(col.title) / 2,
              pdf_position_y + HEADER_PADDING_TOP,
            );

            currentX += col.width;
          });

          pdf_position_y += HEADER_HEIGHT;
        };

        drawHeader();

        // =========================
        // DRAW BODY
        // =========================
        pdf.setFont("Sarabun", "normal");
        pdf.setFontSize(9);

        const paddingX = 2;
        const paddingTop = 12;
        const paddingBottom = 0;
        const lineHeight = 9;

        table1Data.forEach((row, rowIndex) => {
          let currentX = PAGE_MARGIN_X;
          const isLastRow = rowIndex === table1Data.length - 1;
          pdf.setFont("Sarabun", isLastRow ? "bold" : "normal");
          // =========================
          // calculate row height
          // =========================
          let maxLines = 1;

          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            maxLines = Math.max(maxLines, lines.length);
          });

          const rowHeight = maxLines * lineHeight + paddingTop + paddingBottom;

          // =========================
          // page break
          // =========================
          if (pdf_position_y + rowHeight >= pdfHeight - PAGE_MARGIN_TOP) {
            pdf.addPage();

            pdf_position_y = PAGE_MARGIN_TOP;

            drawHeader();
            pdf.setFont("Sarabun", "normal");
            pdf.setFontSize(9);
          }

          // =========================
          // draw row
          // =========================
          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            // border
            pdf.rect(currentX, pdf_position_y, col.width, rowHeight);

            // multiline text
            lines.forEach((line, index) => {
              const textY = pdf_position_y + paddingTop + index * lineHeight;

              if (col.key === "column2" || col.key === "column3") {
                this.thaitext(
                  pdf,
                  line,
                  currentX + col.width / 2 - pdf.getTextWidth(line) / 2,
                  textY,
                );
              } else {
                this.thaitext(pdf, line, currentX + paddingX, textY, {
                  align: "left",
                });
              }
            });

            currentX += col.width;
          });

          pdf_position_y += rowHeight;
        });

        addNewPageIfNeeded(this.pdfConfig.endRow);

        pdf.setDrawColor(0, 0, 0);

        setTimeout(() => {
          pdf.save("รายงานการขายหลักสูตร.pdf");
        }, 0);
        this.localBtnDisabled = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
